
import { defineComponent, PropType } from "vue"

type RadioOption = Record<string, any>
type RadioOptions = RadioOption[]
type RadioValue = RadioOption | string | number | boolean | null

export default defineComponent({
    name: 'new-radio',
    props: {
        value: {
            type: [Object, String, Number, Boolean, null] as PropType<RadioValue>,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            default: 'name',
        },
        selectBy: {
            type: String,
            default: 'id',
        },
        options: {
            type: Array as PropType<RadioOptions>,
            default: () => [],
        },
        returnOption: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const onRadioClick = (option: RadioOption) => {
            if (props.disabled) return
            if (isOptionChecked(option)) return

            const value = getReturningValue(option)

            if (props.returnOption) {
                emit('update:value', { ...(value as RadioOption) })
                emit('change', { ...(value as RadioOption) })

                return
            }

            emit('update:value', value)
            emit('change', value)
        }

        const isOptionChecked = (option: RadioOption) => {
            if (!props.value) return false

            if (props.returnOption) {
                return option[props.selectBy] === (props.value as RadioOption)[props.selectBy]
            }

            return option[props.selectBy] === props.value
        }

        const getReturningValue = (option: RadioOption) => {
            if (props.returnOption) return { ...option }
            return option[props.selectBy]
        }

        return {
            onRadioClick,
            isOptionChecked,
            getReturningValue,
        }
    }
})
